<template>
  <div class="sc-feedback">
    <div class="feedback-icon-container" :class="this.type">
      <i class="feedback-icon" :class="this.icon"></i>
    </div>
    <span class="feedback-text" :class="this.type">{{this.text}}</span>
  </div>
</template>

<script>
export default {
  name: 'ScFeedback',
  props: {
    text: {
      type: String,
      required: false
    },
    icon: {
      type: String,
      required: false,
      default: 'sc-icon-checkbox-checked'
    },
    type: {
      type: String,
      required: false,
      default: 'success'
    }
  }
}
</script>

<style lang="scss" scoped>

.sc-feedback {
  border: 1px solid rgb(211, 218, 223);
  padding: $sc-feedback-padding;
  display: flex;
  align-items: center;

  .feedback-icon-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: $sc-feedback-icon-size;
    height: $sc-feedback-icon-size;
    color: white;
    border-radius: 50%;

    &.success {
      background-color: $sc-feedback-bg-color-success;
    }

    &.error {
      background: $sc-feedback-bg-color-error;
    }
  }

  .feedback-icon {
    font-size: $sc-feedback-icon-font-size;
    float: left;
  }

  .feedback-text {
    float: left;
    margin-left: 20px;

    &.success {
    color: $sc-feedback-color-success;
  }

    &.error {
      color: $sc-feedback-color-error;
    }
  }
}
</style>
